import React from 'react';
import { Navigate } from 'react-router';
import { isAuthen } from '../Services/Auth.service';

export const NoAuthRoute = ({ children }: { children: JSX.Element }) => {
  const auth = isAuthen();
  return auth ? <Navigate to="/" /> : children;
};
